<template>
  <div>
    <div style="position: sticky;top: 80px;z-index: 9999;display: flex;align-items: center;">
      <h1>
        上拉加载
      </h1>
      <h2 class="ml-4">
        {{ text }}
      </h2>
    </div>
    <div class="masonry">
      <v-card
        v-for="item in num"
        :id="item"
        :key="item"
        color="primary"
      >
        {{ item }}
      </v-card>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        text: '拉',
        num: 30,
      }
    },

    mounted() {
      window.addEventListener('scroll', this.onScroll)
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.onScroll)
    },

    methods: {
      onScroll() {
        this.text = '上拉了... 但是没触底'
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        if (scrollTop + clientHeight >= scrollHeight - 50) { 
          // 触底后操作
          this.text = '触底了 开始加载...'
          setTimeout(() => {
            this.text = '加载完了'
            this.num += 10
            setTimeout(() => {
              this.text = '焯...'
            }, 2000)
          }, 2000)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.masonry {
  columns: 6 200px;
  column-gap: 1rem;
  div {
    width: 150px;
    // background: #EC985A;
    color: white;
    margin: 0 1rem 1rem 0;
    display: inline-block;
    width: 100%;
    text-align: center;
    font-family: system-ui;
    font-weight: 900;
    font-size: 2rem;
  } 
  @for $i from 1 through 1080 { 
    div:nth-child(#{$i}) {
      $h: (random(200) + 100) + px;
      height: $h;
      line-height: $h;
    }
  }
}

</style>